module.exports = __webpack_public_path__ + "static/media/thaitvonline1.182439cc.png";